export default __webpack_public_path__ + "static/media/toilet-female.inline.4f7117c5.svg";